export const mockServices = [
  {
    id: 1,
    title: "Local & Short-Distance Moves",
    description: "Whether you're moving across town or to a nearby city, our local moving team ensures a smooth, efficient transition. We handle every detail with care and precision, so you can settle into your new space worry-free.",
    icon: "home"
  },
  {
    id: 2,
    title: "Long-Distance & Cross-Country Moves",
    description: "Planning a move across state lines? ATW specializes in long-distance relocations with real-time tracking, secure transport, and on-time delivery. Your belongings are safe with us from coast to coast.",
    icon: "map-pin"
  },
  {
    id: 3,
    title: "Residential Moving",
    description: "From cozy homes to large estates, we provide comprehensive residential moving services. Our experienced crew handles your furniture, appliances, and personal items with the utmost care and professionalism.",
    icon: "house"
  },
  {
    id: 4,
    title: "Apartment Moving",
    description: "Navigating stairs, elevators, and tight spaces is our specialty. We efficiently move your apartment belongings while protecting walls, floors, and doorways throughout the entire process.",
    icon: "building"
  },
  {
    id: 5,
    title: "Commercial & Office Moves",
    description: "Minimize downtime with our professional office moving services. We coordinate every aspect of your business relocation, ensuring your equipment, files, and furniture arrive safely and on schedule.",
    icon: "briefcase"
  },
  {
    id: 6,
    title: "Same-Day & Last-Minute Moves",
    description: "Need to move quickly? Our same-day moving service provides fast, reliable solutions for urgent relocations. We mobilize our professional crew to meet your immediate moving needs without compromising quality.",
    icon: "clock"
  },
  {
    id: 7,
    title: "Furniture Moving",
    description: "Whether it's a single piece or an entire household, our furniture specialists use proper equipment and techniques to move your valuable pieces safely, preventing scratches, dents, and damage.",
    icon: "armchair"
  },
  {
    id: 8,
    title: "Flat Rate Moving",
    description: "No surprises, no hidden fees. Our transparent flat-rate pricing gives you peace of mind knowing exactly what your move will cost upfront. Budget-friendly moving made simple.",
    icon: "dollar-sign"
  },
  {
    id: 9,
    title: "White Glove / Luxury Moves",
    description: "For high-value items and luxury relocations, our white glove service provides premium care. Custom crating, specialized handling, and meticulous attention ensure your finest possessions receive VIP treatment.",
    icon: "star"
  },
  {
    id: 10,
    title: "Senior Moving Services",
    description: "We understand that moving later in life requires extra patience and care. Our compassionate team provides gentle, respectful service to help seniors transition smoothly to their new home or community.",
    icon: "heart"
  },
  {
    id: 11,
    title: "Packing & Unpacking Services",
    description: "Save time and stress with our professional packing services. We supply quality materials and expertly pack your belongings for maximum protection, then unpack and arrange items in your new space.",
    icon: "package"
  },
  {
    id: 12,
    title: "Secure Storage Solutions",
    description: "Need temporary storage during your move? Our clean, climate-controlled facilities keep your belongings safe and secure for as long as you need, with easy access and flexible terms.",
    icon: "warehouse"
  }
];

export const mockBenefits = [
  {
    id: 1,
    title: "Upfront & Fair Pricing",
    description: "Transparent quotes with no hidden fees or surprises",
    icon: "dollar-sign"
  },
  {
    id: 2,
    title: "Flexible Scheduling",
    description: "We work around your schedule, including weekends and holidays",
    icon: "calendar"
  },
  {
    id: 3,
    title: "Real-Time Customer Support",
    description: "Dedicated support team available throughout your move",
    icon: "headphones"
  },
  {
    id: 4,
    title: "Well-Maintained Equipment",
    description: "Modern trucks and professional-grade moving supplies",
    icon: "truck"
  },
  {
    id: 5,
    title: "Trained & Vetted Movers",
    description: "Background-checked professionals committed to excellence",
    icon: "user-check"
  },
  {
    id: 6,
    title: "Strong Reputation",
    description: "Trusted by thousands of satisfied customers nationwide",
    icon: "award"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Robert Martinez",
    location: "Dallas, TX",
    review: "ATW Against the Wind made our cross-country move completely stress-free. The crew was professional, careful with our belongings, and arrived exactly on time. Not a single item was damaged. Highly recommend!"
  },
  {
    id: 2,
    name: "Jennifer Thompson",
    location: "Seattle, WA",
    review: "Best moving experience we've ever had. The team was courteous, efficient, and took great care with our furniture. Communication was excellent from start to finish. Worth every penny."
  },
  {
    id: 3,
    name: "Michael Chen",
    location: "Atlanta, GA",
    review: "We needed a last-minute move and ATW came through for us. Their same-day service was incredible. The movers were careful, fast, and very professional. They treated our belongings like their own."
  },
  {
    id: 4,
    name: "Patricia Williams",
    location: "Phoenix, AZ",
    review: "Helped my elderly mother relocate across state lines. The crew was patient, understanding, and extremely careful. They went above and beyond to make the transition smooth. Truly grateful for their service."
  },
  {
    id: 5,
    name: "David Johnson",
    location: "Boston, MA",
    review: "Our office relocation was handled flawlessly by ATW. They moved all our equipment and furniture over the weekend without disrupting our business. Professional crew and fair pricing."
  },
  {
    id: 6,
    name: "Sarah Anderson",
    location: "Denver, CO",
    review: "From the initial quote to the final box being unloaded, everything was perfect. The movers were punctual, careful, and remarkably efficient. No hidden fees, just honest service."
  },
  {
    id: 7,
    name: "James Rodriguez",
    location: "Miami, FL",
    review: "Moved our three-bedroom home with ATW and couldn't be happier. The team was respectful of our property, packed everything securely, and delivered on schedule. Zero damage and great communication throughout."
  }
];

export const mockTrustBadges = [
  {
    id: 1,
    title: "Licensed & Insured",
    icon: "shield-check"
  },
  {
    id: 2,
    title: "Trained Professionals",
    icon: "users"
  },
  {
    id: 3,
    title: "Nationwide Service",
    icon: "map-pin"
  },
  {
    id: 4,
    title: "5-Star Rated",
    icon: "star"
  }
];